<template>
    <div>
        <BreadCrumb v-if="this.mode !== 'comp' " :data="breadCrumb" />
        <Table 
            :fields="fields" :items="ticketList" :filtered="filtered" type="List" :loading="isLoading" :limit="limit" :setLimit="setLimit" :page="page"
            :setPage="setPage" :pageData="pageInfo" :actions="actions" :actionEvent="actionEvent" :goDetail="goDetail"
            :inputs="inputs" :search="search" :gSearch='gSearch' :mode="this.mode" />

        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/";

    let breadCrumb = [
        { label: i18n.t('pages.ticket.name'), url: "/Ticket/List" },
    ]

     let fields = [ 
         { key: 'id', label: i18n.t('ticket.detail.id'), keys:['id'] },
         { key: 'title', label: i18n.t('ticket.detail.title'), keys:['title'] },
         { key: 'subName', type: 'badge', label: 'Abonelik', keys:['customer_sub', 'subscription_name'] },
         { key: 'customer', label: 'Müşteri', keys:['customer', 'name'] },
         { key: 'appointed_person', label: i18n.t('ticket.detail.assignedUser'), keys:['assigned_user'] },
         { key: 'created_at', type:"date", label: i18n.t('ticket.detail.date'), keys:['created_at'] },
         { key: 'updated_at', type:"date", label: i18n.t('ticket.detail.updatedAt'), keys:['updated_at'] },
         { key: 'status_badge', label: i18n.t('ticket.detail.status'), keys:['support_status']},
         { key: 'result', type: 'badge', label: 'Sonuç', keys:['status', 'description'] },
         { key: 'expire', type:"expiredIn", label: 'Abonelik Bitişi', keys:['customer_sub', 'end_date']},
         { key: 'actions', label: i18n.t('ticket.form.operations')}
    ]; 
     let inputs = [ 
        { key: 'id', label: i18n.t('ticket.detail.id'), type: "Number", checked: false, val:""},
        { key: 'title', label: i18n.t('ticket.detail.title'), type: "String", checked: false, val:""},
        { key: 'customerName', label: i18n.t('ticket.form.clientName'), type: "String", checked: false, val:""},
        { key: 'customerSub', label: i18n.t('ticket.form.subscription'), type: "String", checked: false, val:""},
        { key: 'customerProductSeriNo', label: i18n.t('ticket.form.serialNumber'), type: "String", checked: false, val:""},
        { key: 'status', label: i18n.t('ticket.detail.status'), type: "Select", checked: false, val:"",  array:[
            {text: i18n.t('ticket.input.active'), value: 'Aktif'},
            {text: i18n.t('ticket.input.complete'), value: 'Pasif'},
        ]},
        { key: 'assignedUser', label: i18n.t('ticket.detail.assignedUser'), type: "String", checked: false, val:""}
    ]; 
     let actions = [
        // {key: 'active', text: i18n.t('ticket.actions.active'), state: true},
        {key: 'close', text: i18n.t('ticket.actions.complete'), state: false},
        {key: 'report', text: 'Rapor Al'},
        {key: 'appointment', text: 'Atama Yap'},
        {key: 'changeState', text: 'Durum Değiştir'},

    ]

    let filtered = ['title', 'customer', 'updated_at', 'status_badge', 'actions', 'expire', 'result']; 

    export default {
        name: 'TicketList',
         watch:{
            limit(val){
                this.params['limit'] = val
                this.$store.dispatch('fetchTickets', this.params)

            },
            offset(val){
                 this.params['offset'] = val
                 this.$store.dispatch('fetchTickets', this.params)

            }
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, limit:10, page: 1, offset: 0, actions, modalOpen: false,
                modalProps: {}, currentForm:"Ticket", modalName: "", dismissCountDown: 0, inputs,
                params:{
                    limit:10,
                    offset: 0,
                }
            }
        },
        components:{
            BreadCrumb, Table, Modals
        },
        props:{
            mode: String
        },
        computed: {
            isLoading() {
                return this.$store.getters.getTicketLoading
            },
            pageInfo() {
                return this.$store.getters.getTicketPageInfo  
            },
            ticketList() {
                return this.$store.getters.ticketList
                .map(ticket => {
                    return {
                        ...ticket,
                        assigned_user: ticket.assigned_user.first_name ? 
                            `${ticket.assigned_user.first_name} ${ticket.assigned_user.last_name}` : 
                            ticket.assigned_user.id ? 
                                i18n.t('ticket.user') : 
                                i18n.t('ticket.detail.notAssigned')
                    }
                })
            },
        },
        methods:{
            search(){
                this.inputs.map((input)=>{
                    input.checked ? this.params[input.key] = input.val : delete this.params[input.key] 
                })
                this.$store.dispatch('fetchTickets', this.params)
            },
            gSearch(data){
                data.length > 0 ? this.params['comment'] = data : delete this.params['comment']
                this.$store.dispatch('fetchTickets', this.params)
            },
            goDetail(item){
                this.$router.push( { path: '/Ticket/'+item.id+'/detail' })
            },
            setLimit:function(limit){
                this.limit = limit
                this.params.limit = limit
            },
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.offset = ((page-1) * this.limit)
                    this.params.offset = ((page-1) * this.limit)
                }
            },
            actionEvent: async function (key, data) {
                if (key == 'close') return this.openModal(true, 'state', { ticket: data, state: false })
                this.openModal(true, key, { ticket: data });
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state) {
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        },
        created() {
            this.$store.dispatch('fetchTickets', this.params)
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/List.vue